import React, { useState } from 'react';
import { Alert, Button, Input, Statistic } from 'antd';
import { EaseModal } from '../../../libs/EaseModal';
import { Text3, Text4 } from '../../../styles';
import { MerchantService } from '../../../services';
import { handleApiExceptions } from '../../../app_methods';
import moment from 'moment';


const SoftLockModal = (props) => {
    const [OTP, setOTP] = useState("");
    const [countdown, setCountdown] = useState(moment());
    const [showResetButton, setShowResetButton] = useState(false);
    const [isOTPSent, setIsOTPSent] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isDisabling, setIsDisabling] = useState(false);

    const resetCountdown = () => setCountdown(moment().add(180, "seconds"));

    const generateOTP = () => {
        setIsLoading(true);
        MerchantService.generate_soft_lock_otp().then(response => {
            if (response.success) {
                setIsLoading(false);
                setIsOTPSent(true);
                resetCountdown();
                setShowResetButton(false);
            }
            else {
                setIsLoading(false);
                handleApiExceptions(response.data.message || "Something went wrong.");
            }
        }).catch(error => {
            setIsLoading(false);
            handleApiExceptions(error);
        })
    };

    const disableSoftLock = () => {
        if (!OTP) return;
        setIsDisabling(true);
        MerchantService.disable_soft_lock({ otp: OTP }).then(response => {
            if (response.success) {
                setIsDisabling(false);
                props.postAuthentication();
            }
            else {
                setIsDisabling(false);
                handleApiExceptions(response.data.message || "Something went wrong.");
            }
        }).catch(error => {
            setIsDisabling(false);
            handleApiExceptions(error);
        })
    };

    const renderCountdown = () => showResetButton ?
        <Button className="m-0" type="link" size="small" loading={isLoading} onClick={generateOTP}>Resend OTP</Button>
        :
        <Statistic.Countdown
            valueStyle={{ fontSize: 14, opacity: 0.8 }}
            value={countdown}
            format="mm:ss"
            onFinish={() => setShowResetButton(true)}
        />;

    return (
        <EaseModal
            width={450}
            title={false}
            visible={props.visible}
            closable={false}
            centered
            hideFooter
        >
            <Alert
                className="mb-4"
                type="error"
                message="Authentication Required"
                description="Your account has been locked due to too many hash mismatches. In order to unlock your account, kindly authenticate."
            />
            {
                !isOTPSent ?
                    <>
                        <Text4 className="d-block" strong>You will receive an OTP on your registered email ID:</Text4>
                        <Text3>{props.merchant.email}</Text3><Button type="link" loading={isLoading} onClick={generateOTP}>Send OTP</Button>
                    </>
                    :
                    <>
                        <Text4 strong>Enter OTP:</Text4>
                        <Input autoComplete='off' onChange={(e) => setOTP(e.target.value)} onPressEnter={disableSoftLock} addonAfter={renderCountdown()} />
                        <div className="mt-4 d-flex justify-content-end">
                            <Button type="primary" loading={isDisabling} onClick={disableSoftLock}>Submit</Button>
                        </div>
                    </>
            }
        </EaseModal>
    )
};

export { SoftLockModal };